export default __webpack_public_path__ + "static/media/Slide-2.68b6d3a7.png";